import { render, staticRenderFns } from "./trustpilotComponent.vue?vue&type=template&id=27a62d1f&scoped=true&"
import script from "./trustpilotComponent.vue?vue&type=script&lang=js&"
export * from "./trustpilotComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a62d1f",
  null
  
)

export default component.exports